import { EMPTY_STRING } from "shared/constants";
import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  termsOfContract: null,
  contractReference: EMPTY_STRING,
};
